import { fr, Translations } from './fr';
import { en } from './en';
import { de } from './de';
import { es } from './es';
import { it } from './it';
import { ar } from './ar';
import { nl } from './nl';
import { pt } from './pt';
import { ja } from './ja';
import { zh } from './zh';
import { Language } from '../types';

export const translations: Record<Language, Translations> = {
  fr,
  en,
  de,
  es,
  it,
  ar,
  nl,
  pt,
  ja,
  zh,
};

export type { Translations };
